import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Perdés ventas porque no sabés explicar la diferencia entre un Malbec de Luján y uno del Valle de Uco', 'Tus clientes se van sin comprar porque no los guiaste con seguridad hacia el vino correcto', 'Cada vez que organizás una cata improvisás sin tener una ficha profesional para guiarte', 'No sabés cómo manejar el stock para que no queden vinos parados meses en la góndola', 'Tus redes sociales están abandonadas porque no sabés qué publicar sobre vino que genere ventas', 'Cuando llega la temporada de fiestas no tenés armada una guía de maridajes para ofrecer', 'Querés abrir o escalar tu vinoteca pero no tenés el plan de negocio ni las herramientas', 'Sentís que tu nivel de conocimiento no está a la altura de lo que tus clientes esperan'];
  return <section className="py-20 bg-[#0d0716]" data-id="element-296">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-298">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-299">
            ❓ ¿Cuántos clientes más vas a perder por no tener el conocimiento
            correcto?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 text-left md:text-center max-w-3xl mx-auto" data-id="element-300">
            <p className="text-[14px]" data-id="element-301">
              Tal vez ya buscaste información suelta en YouTube que no tiene una
              secuencia lógica. Tal vez armás tus propias listas de vinos desde
              cero cada temporada. Tal vez cuando un cliente te pregunta por un
              maridaje específico no tenés una respuesta que le dé confianza
              para comprar.
            </p>
            <p data-id="element-302">
              <strong className="text-white text-[16px]" data-id="element-303">
                No es falta de pasión por el vino. Es que nadie armó el sistema
                completo para vos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-purple-950/30 border border-purple-900/50 rounded-2xl p-6 md:p-8" data-id="element-304">
          <h3 className="text-xl font-bold text-slate-200 mb-6 text-center" data-id="element-305">
            😓 Esto te está pasando ahora mismo:
          </h3>
          <ul className="space-y-4" data-id="element-306">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-307">
                <div className="mt-1 bg-purple-500/20 p-1 rounded-full shrink-0" data-id="element-308">
                  <X className="w-4 h-4 text-purple-400" data-id="element-309" />
                </div>
                <span className="text-slate-200 font-medium text-[14px]" data-id="element-310">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-311">
          <p className="font-bold text-slate-300 text-[16px]" data-id="element-312">
            ¿Y si esta fuera la última semana que atendés sin tener todo el
            conocimiento resuelto?
          </p>
        </div>
      </div>
    </section>;
}